export default __webpack_public_path__ + "static/media/us_phone.2d8a5c45.csv";